import React, { useState } from "react";

import { PlainTooltip } from "@similarweb/ui-components";

import { InfoIcon } from "pro-features/components/BoxTitle/src/BoxTitle";
import { AddToDashboard } from "app/components/dashboard/AddToDashboard/AddToDashboard";
import { DropdownReact } from "app/components/dropdown/dropdown-react";
import { i18nFilter } from "app/filters/i18nFilter";
import { numberFilter } from "app/filters/ngFilters";
import {
    MetricTitle,
    NoData,
    TableLoader,
    SeeMore,
} from "app/pages/keyword-analysis/TotalTrafficPage/Components/UtilityComponents";
import { Text } from "app/pages/keyword-analysis/TotalTrafficPage/StyledComponents";
import { selectedTabTypes } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewTraffic/SearchOverviewTrafficTables";
import {
    ButtonContainer,
    DropdownWrapper,
    MetricTitleWithDropdownWrapper,
    CtaWrapper,
    TableContainer,
    TitleContainerCompare,
    TitleWithDropdownWrapper,
    RightSideOfTitle,
} from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewTraffic/StyledComponent";
import { SourceType } from "app/pages/website-performance/components/SearchTraffic/WWOTopKeywords";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { DefaultFetchService } from "app/services/fetchService";

import { SearchOverviewTableComponentCompare } from "./SearchOverviewTableComponentCompare";
import { SearchOverviewTopKeywordTableComponentCompare } from "./SearchOverviewTopKeywordTableComponentCompare";

const TableRowsAmount = 5;
const fontSize = 16;
const searchTrafficByItems = [
    {
        id: "SearchTrafficByChannel",
        text: "Search Traffic By Type",
        headTemp: "leader-default-header-cell",
    },
    {
        id: "SearchTrafficByEngines",
        text: "Search Traffic By Engines",
        headTemp: "leader-domain-header-cell",
    },
];

export const SearchOverviewTopOrganicKeywordsCompare = (props) => {
    const TopOrganicKeywordsroutingParams = { ...props.routingParams, IncludeOrganic: "true" };
    const queryParams = { ...props.queryParams, SourceType: SourceType.ORGANIC, pageSize: TableRowsAmount };
    const HeadLineKey = "search.overview.topKeyword.organic.head.line.key";
    const SeeAllKey = `search.overview.topKeyword.organic.see.all`;
    const KeywordTooltipKey = "analysis.source.search.overview.topKeyword.organic.compare.tooltip";
    const SitesEndPoint = "widgetApi/SearchKeywordsV2/Table";
    const InnerLinkPage = "organicsearch_websites_v2_traffic_keywords";
    const selectedTab = selectedTabTypes.organic;
    const ComponentName = "TopOrganicKeywords";
    const isTopKeywordComponent = true;
    const Constants = {
        SitesEndPoint,
        HeadLineKey,
        KeywordTooltipKey,
        SeeAllKey,
        InnerLinkPage,
        ComponentName,
        selectedTab,
        isTopKeywordComponent,
    };
    return (
        <SearchOverviewTrafficTablesCompare
            routingParams={TopOrganicKeywordsroutingParams}
            {...Constants}
            queryParams={queryParams}
        />
    );
};

export const SearchOverviewTopPaidKeywordsCompare = (props) => {
    const TopPaidKeywordsRoutingParams = { ...props.routingParams, limits: "competitive" };
    const queryParams = {
        ...props.queryParams,
        limits: "0.2-0.6;0.2-0.6",
        pageSize: TableRowsAmount,
        SourceType: SourceType.PAID,
    };
    const HeadLineKey = "search.overview.topKeyword.paid.head.line.key";
    const SeeAllKey = `search.overview.topKeyword.paid.see.all`;
    const KeywordTooltipKey = "analysis.source.search.overview.topKeyword.competitive.compare.tooltip";
    const SitesEndPoint = "widgetApi/SearchKeywordsV2/Table";
    const InnerLinkPage = "organicsearch_websites_v2_traffic_keywords";
    const selectedTab = selectedTabTypes.paid;
    const ComponentName = "TopPaidKeywords";
    const isTopKeywordComponent = true;
    const Constants = {
        SitesEndPoint,
        HeadLineKey,
        KeywordTooltipKey,
        InnerLinkPage,
        ComponentName,
        SeeAllKey,
        selectedTab,
        isTopKeywordComponent,
    };
    return (
        <SearchOverviewTrafficTablesCompare
            routingParams={TopPaidKeywordsRoutingParams}
            {...Constants}
            queryParams={queryParams}
        />
    );
};

const SearchOverviewTrafficTablesInner = (props) => {
    const {
        queryParams,
        routingParams,
        SitesEndPoint,
        HeadLineKey,
        KeywordTooltipKey,
        SeeAllKey,
        InnerLinkPage,
        ComponentName,
        isTopKeywordComponent,
        searchBy: searchByProp,
        defaultApiCall,
        searchOverviewTrafficListParser,
    } = props;
    const [searchOverviewTrafficData, setSearchOverviewTrafficData] = useState({
        searchOverviewTrafficList: {},
        searchName: "",
        TotalCount: 0,
    });
    const [selectedSearchBy, setSelectedSearchBy] = useState(
        isTopKeywordComponent ? "" : searchTrafficByItems.find((item) => item.id === defaultApiCall).id,
    );
    const { searchOverviewTrafficList } = searchOverviewTrafficData;
    const [isLoading, setIsLoading] = useState(true);

    const setData = async ({
        endPoint = SitesEndPoint,
        nameSearchBy = searchByProp,
        searchOverviewTrafficListParser,
    }) => {
        const searchBy = nameSearchBy;
        const apiParams = { ...queryParams };
        const fetchService = DefaultFetchService.getInstance();
        const SitesDataPromise = fetchService.get(endPoint, apiParams);
        let SitesData;
        try {
            SitesData = await SitesDataPromise;
        } catch {
            setIsLoading(false);
        }
        const searchOverviewTrafficList = SitesData ? SitesData["Data"]?.slice(0, TableRowsAmount) : [];
        if (searchOverviewTrafficList.length === 0) {
            setIsLoading(false);
            return;
        }
        setSearchOverviewTrafficData({
            searchOverviewTrafficList: searchOverviewTrafficListParser
                ? searchOverviewTrafficListParser(searchOverviewTrafficList, nameSearchBy)
                : searchOverviewTrafficList,
            searchName: searchBy,
            TotalCount: SitesData.TotalCount,
        });
        setIsLoading(false);
    };

    React.useEffect(() => {
        setData({ searchOverviewTrafficListParser });
    }, [queryParams]);
    const i18n = i18nFilter();
    const innerLink = proNavigator.href(InnerLinkPage, { ...routingParams, IncludeNoneBranded: true });
    const decodedLink = decodeURIComponent(innerLink);
    const headline = i18n(HeadLineKey);
    const totalCount = numberFilter()(searchOverviewTrafficData.TotalCount);

    const onDropdownChange = (item) => {
        setSelectedSearchBy(item.id);
        setData({
            endPoint: `/widgetApi/TrafficSourcesSearch/${item.id}/Table`,
            nameSearchBy: item.id,
            searchOverviewTrafficListParser,
        });
    };
    const renderMetricTitleWithDropdown = ({ tooltip, headline }) => {
        return (
            <MetricTitleWithDropdownWrapper>
                <RightSideOfTitle>
                    <TitleWithDropdownWrapper>
                        <Text
                            fontSize={20}
                            fontWeight={500}
                        >
                            {headline}
                        </Text>
                    </TitleWithDropdownWrapper>
                    <DropdownWrapper>
                        <DropdownReact
                            selected={selectedSearchBy}
                            onChange={onDropdownChange}
                            items={searchTrafficByItems}
                        />
                    </DropdownWrapper>
                    <PlainTooltip
                        placement="top"
                        tooltipContent={tooltip}
                    >
                        <span>
                            <InfoIcon iconName="info" />
                        </span>
                    </PlainTooltip>
                </RightSideOfTitle>
                <AddToDashboard
                    metric="SearchTrafficByEngines"
                    modelType="fromWebsite"
                    webSource="Desktop"
                    type="TableDynamicColumnsLeader"
                />
            </MetricTitleWithDropdownWrapper>
        );
    };
    return (
        <>
            <TitleContainerCompare>
                {isTopKeywordComponent ? (
                    <MetricTitle
                        headline={headline}
                        tooltip={i18n(KeywordTooltipKey)}
                        fontSize={fontSize}
                    />
                ) : (
                    renderMetricTitleWithDropdown({
                        headline,
                        tooltip: i18n(KeywordTooltipKey),
                    })
                )}
            </TitleContainerCompare>
            {isLoading ? (
                <TableLoader />
            ) : !searchOverviewTrafficList || Object.values(searchOverviewTrafficList).length === 0 ? (
                <NoData
                    paddingTop={"50px"}
                    paddingBottom={"50px"}
                    noDataTitleKey={"search.overview.no.data.title"}
                    noDataSubTitleKey={"search.overview.no.data.sub.title"}
                />
            ) : (
                <>
                    <TableContainer withPaddedRows={isTopKeywordComponent}>
                        {isTopKeywordComponent ? (
                            <SearchOverviewTopKeywordTableComponentCompare
                                searchOverviewTrafficData={searchOverviewTrafficData}
                                routingParams={routingParams}
                                keys={queryParams.keys}
                            />
                        ) : (
                            <SearchOverviewTableComponentCompare
                                searchOverviewTrafficData={searchOverviewTrafficData}
                                routingParams={routingParams}
                            />
                        )}
                    </TableContainer>
                    {SeeAllKey ? (
                        <ButtonContainer>
                            <CtaWrapper>
                                <SeeMore
                                    componentName={ComponentName}
                                    innerLink={decodedLink}
                                    textAlign={"end"}
                                >
                                    {i18n(SeeAllKey, { totalCount })}
                                </SeeMore>
                            </CtaWrapper>
                        </ButtonContainer>
                    ) : null}
                </>
            )}
        </>
    );
};

const propsAreEqual = (prevProps, nextProps) => prevProps.queryParams?.key === nextProps.queryParams?.key;
const SearchOverviewTrafficTablesCompare = React.memo(SearchOverviewTrafficTablesInner, propsAreEqual);
